module.exports = __webpack_public_path__ + "img/package.ab41dfb8.png";